module.exports = __webpack_public_path__ + "static/media/Apr15-S19.6d585f35.png";